import { zKey } from '@nucleus/ncu-key-prefix';
import { WebHostingRouterInput } from '@nucleus/web-hosting';
import { useWebHostingApi } from '@nucleus/web-theme';
import { infiniteQueryOptions, useSuspenseInfiniteQuery } from '@tanstack/react-query';

type PostListInput = WebHostingRouterInput['postHub']['post']['list'];

export const usePosts = (engineId: string | undefined, params?: Omit<PostListInput, 'hubId'>) => {
  const api = useWebHostingApi();

  const hasEngineId = zKey.prefixedKey().safeParse(engineId).success;

  const options = api.postHub.post.list.infiniteQueryOptions(
    {
      hubId: engineId!,
      ...params,
    },
    {
      getNextPageParam: (lastPage) => lastPage.cursor,
    }
  );

  const defaultOptions = infiniteQueryOptions({
    queryKey: options.queryKey,
    queryFn: async () => ({ posts: [], cursor: undefined }),
    initialPageParam: undefined,
    getNextPageParam: () => undefined,
  }) as unknown as typeof options;

  return useSuspenseInfiniteQuery(hasEngineId ? options : defaultOptions);
};
